import React, { useState, useEffect } from 'react';
import { TrackingProp } from 'react-tracking';
import GlobalLayout from 'components/Layouts/GlobalLayout';
import ProductTabs from 'components/ProductTabs';
import useLazyLoad from 'hooks/useLazyLoad';
import { useTrackPageViewed } from 'analytics/itly/hooks';
import withCart from 'components/PageWrapper/withCart';
import { analyticsWrapper } from 'analytics/itly/analyticsWrapper';
import Helmet from 'react-helmet';
import { getGatsbySiteUrl, getGoogleSiteVerificationKey } from 'helpers/env';
import { useGoogleReCaptcha } from 'features/google-recaptcha';
import { useTikTok } from 'hooks/useTikTok';
import Block from 'components/CMS/Block';
import { HomeHeroBlock } from 'components/CMS/HomeHeroBlock';
import { HomeHtmlBlock } from 'components/CMS/HomeHtmlBlock';
import { HomeH1 } from 'components/HomeH1';
import { ReturnToProject } from 'components/ReturnToProject';
import { getReturnToProjectData } from 'helpers/projects/returnToProject';

interface Props {
  tracking: TrackingProp;
}

function IndexPage({ tracking }: Props) {
  const [showReturnToProject, setShowReturnToProject] = useState(false);

  useEffect(() => {
    const showReturnToProject = getReturnToProjectData();
    setShowReturnToProject(showReturnToProject != null);
  }, []);

  useLazyLoad();
  useTrackPageViewed(tracking, 'HomePage', 'Home Page');
  useGoogleReCaptcha({ pageType: 'HomePage', pageName: 'Home Page', action: 'home' });
  useTikTok({ event: 'PageView' });
  return (
    <GlobalLayout tracking={tracking} displayPromoBanner displayProductAssistant contained={false}>
      <Helmet link={[{ rel: 'canonical', href: getGatsbySiteUrl() }]} />
      <Helmet meta={[{ name: 'google-site-verification', content: getGoogleSiteVerificationKey() }]} />
      {showReturnToProject && <ReturnToProject dismiss={() => setShowReturnToProject(false)} />}
      <HomeHeroBlock blur={showReturnToProject} />
      <HomeH1 />
      <Block id="au_commerce_home_product_tabs" render={(products) => <ProductTabs products={products} />} asJson />
      <HomeHtmlBlock id="au_commerce_home_categories" />
      <HomeHtmlBlock id="au_commerce_home_quality_guarantee" />
      <HomeHtmlBlock id="au_commerce_home_video_block" />
      <HomeHtmlBlock id="au_commerce_home_press" />
    </GlobalLayout>
  );
}

export default analyticsWrapper(withCart(IndexPage));
